// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ry_p","toggleWrap":"styles_toggleWrap__33tHh","content":"styles_content__3wi2J","selectAreaCode":"styles_selectAreaCode__2H_Nf"};